const gallerySnip = (layout) => {
    return `<div class="gallery ${layout}">

        <div class="item">
            <img src="https://images.pexels.com/photos/274131/pexels-photo-274131.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260" />
        </div>

        <div class="item">
            <img src="https://images.pexels.com/photos/333850/pexels-photo-333850.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260" />
        </div>

        <div class="item">
            <img src="https://images.pexels.com/photos/338713/pexels-photo-338713.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260" />
        </div>
        
        <div class="item">
            <img src="https://images.pexels.com/photos/2792116/pexels-photo-2792116.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260" />
        </div>

    </div>`
}

export default gallerySnip